<template>
  <div class="landingPage" :class="{ 'is-overlapped': isHeaderOverlapped }">
    <!--头部-->
    <Navbar :isNotify="false" :isCustomerService="false" :showLeft="false">
      <template #left>
        <div class="left-content">
          <img
            class="guide-logo-icon"
            src="@/assets/style/landingPage/landpage-logo.png"
            alt=""
          />
          <div class="text">
            <span class="span">前程乐享</span>
            <span class="tip">应急不用等 周转更轻松</span>
          </div>
        </div>
      </template>
      <template #right>
        <div class="right-content">
          <img src="@/assets/style/customer-service-icon.png" alt="" />
        </div>
      </template>
    </Navbar>
    <div ref="contentSentinel" class="content-sentinel"></div>
    <!--卡片-->
    <pageCard ref="pageCardRef" />
    <!--输入手机号-->
    <div class="phoneField">
      <phoneField v-model="phone" ref="phoneFieldRef" />
    </div>
    <!--登录协议-->
    <div class="protocolField">
      <protocolField
        v-model="isChecked"
        labelColor="#333333"
        protocolColor="#0088FF"
        protocolType="3"
        routerName="landingPage"
        isLogin
      />
    </div>
    <!--绑定渠道-->
    <div class="bindChannel">
      <van-button class="btn" type="primary" block @click="handleBind"
        >立即领取额度</van-button
      >
    </div>
    <!--保障申明-->
    <div class="warrantyStatement">
      <warrantyStatement />
    </div>
    <div class="riskTip">
      贷款有风险，借贷需谨慎，请根据个人能力合理贷款
      贷款额度、利率、放款时间以实际审核为准
    </div>
    <Popup
      ref="popup"
      message="请先阅读并同意相关协议"
      confirmText="同意并继续"
      cancelText="不同意"
      @confirm="handleConfirm"
    />
  </div>
</template>

<script>
import { bindChannel, setViewCount } from "@/api/index.js";
import Navbar from "@/components/navbar/index.vue";
import pageCard from "@/components/landingPage/pageCard.vue";
import phoneField from "@/components/landingPage/phoneField.vue";
import protocolField from "@/components/protocolField/index.vue";
import warrantyStatement from "@/components/landingPage/warrantyStatement.vue";
import Popup from "@/components/Popup/index.vue";
import checkEnvironment from "@/hooks/checkEnvironment.js";

export default {
  name: "LandingPage",
  components: {
    Navbar,
    pageCard,
    phoneField,
    protocolField,
    warrantyStatement,
    Popup
  },
  data() {
    return {
      isChecked: false,
      phone: "",
      isHeaderOverlapped: false,
      code: "",
    };
  },
  async activated() { 
    checkEnvironment();
    this.$nextTick(() => {
      this.initHeaderOverlapObserver();
    });
  },
  methods: {
    handleConfirm() {
      this.isChecked = true;
    },
    initHeaderOverlapObserver() {
      const sentinelEl = this.$refs.contentSentinel;
      if (!sentinelEl || typeof IntersectionObserver === "undefined") return;

      const rootEl = this.$el;
      this._contentObserver?.disconnect();
      this._contentObserver = new IntersectionObserver(
        ([entry]) => {
          this.isHeaderOverlapped = entry ? !entry.isIntersecting : false;
        },
        {
          root: rootEl,
          threshold: 0,
          rootMargin: `-${46}px 0px 0px 0px`,
        },
      );
      this._contentObserver.observe(sentinelEl);
    },
    //渠道绑定
    async handleBind() {
      if (!this.phone) {
        this.$toast("请输入手机号");
        return;
      }
      if (!this.isChecked) {
        this.$refs.popup.showPopup();
        return;
      }
      const res = await bindChannel(this.$store.state.channelId, {
        phoneNumber: this.phone,
        code: this.code,
      });
      if (res.code === 2000) {
        //浏览量结算
        await setViewCount({
          channelId: this.$store.state.channelId,
        });
        this.$router.push({
          path: "/landingPageResule",
        });
      } else {
        this.$toast(res.msg || res.message || "绑定失败");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.landingPage {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-color: #F5F6F7;
  background-image: url("@/assets/style/landingPage/landpage-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.content {
  position: absolute;
  z-index: 2;
  width: 100%;
  .content-wrap {
    margin: 16px;
  }
}
.landingPage-img {
  position: absolute;
  top: 0;
  right: 0;
  img {
    width: 198px;
    height: 131px;
  }
}
 ::v-deep(.van-nav-bar) {
    padding-top: 6px;
    padding-bottom: 2px;
  }
.landingPage.is-overlapped {
  ::v-deep(.van-nav-bar) {
    background: #feefe6  !important;
  }
  ::v-deep(.van-nav-bar__title) {
    color: #fff;
  }
}
::v-deep(.van-nav-bar) {
  background: transparent !important;
}
.left-content {
  display: flex;
  align-items: center;
  color: #1d70f7;
  .text {
    margin-left: 6px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 12px;
    color: #573119;
    .span {
      font-size: 16px;
      font-weight: 600;
    }
    .tip{
      margin-top: -4px;
    }
  }
  img {
    width: 36px;
    height: 36px;
  }
}
.right-content {
  img {
    height: 24px;
  }
}
.phoneField,.codeField {
  margin-top: 16px;
  padding: 0px 20px;
}
.bindChannel {
  margin-top: 16px;
  padding: 0px 20px;
  .btn {
    background: #EF4143;
    border-radius: 30px;
    border: none;
    color: #fff;
  }
}
.protocolField {
  margin-top: 16px;
  padding: 0px 20px;
}
.warrantyStatement {
  margin-top: 16px;
  padding: 0px 20px;
}
.riskTip {
  margin-top: 16px;
  padding: 0px 20px;
  font-size: 12px;
  color: #333333;
  text-align: center;
  margin-bottom: 30px;
}
.content-sentinel {
  position: absolute;
  top: 46px;
  left: 0;
  width: 1px;
  height: 1px;
}
.value{
  flex: 1;
  .get-code{
    margin-right: 20px;
  }
}
</style>
